class OiImageGallery {
    private galleryElement: HTMLElement;
    private slider: HTMLElement | null;
    private items: HTMLElement[];
    private prevBtn: HTMLElement | null;
    private nextBtn: HTMLElement | null;
    private lightbox: HTMLElement | null;
    private lightboxImg: HTMLImageElement | null;
    private currentIndex = 0;
    private bodyElement: HTMLElement | null


    constructor(galleryElement: HTMLElement) {
        this.galleryElement = galleryElement;
        this.slider = this.galleryElement.querySelector('.image-slider')|| this.galleryElement.querySelector('.propertyTeaser');
        this.prevBtn = this.galleryElement.querySelector('.prev-btn');
        this.nextBtn = this.galleryElement.querySelector('.next-btn');
        this.lightbox = this.galleryElement.querySelector('.lightbox');
        this.bodyElement = document.querySelector('body')

        this.lightboxImg = this.lightbox
            ? this.lightbox.querySelector('.lightbox-content img')
            : null;

        if (!this.slider) return;

        this.items = Array.from(this.slider.querySelectorAll<HTMLElement>('.gallery-item'));
        this.initGallery();
    }

    private initGallery(): void {
        // Set image orientations

        if (this.items.length < 4) {
            if (this.prevBtn) {
                this.prevBtn.classList.add("disabled");
                this.prevBtn.setAttribute("disabled", "true");
            }
            if (this.nextBtn) {
                this.nextBtn.classList.add("disabled");
                this.nextBtn.setAttribute("disabled", "true");
            }
        } else {
            if (this.prevBtn) {
                this.prevBtn.addEventListener("click", () => this.scrollByDirection(-1));
            }
            if (this.nextBtn) {
                this.nextBtn.addEventListener("click", () => this.scrollByDirection(1));
            }
        }

        // Lightbox functionality (optional)
        if (this.lightbox && this.lightboxImg) {
            this.items.forEach((item, index) => {
                item.addEventListener('click', () => this.openLightbox(index));
            });

            const closeBtn = this.lightbox.querySelector('.close-btn-fs');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                    this.galleryElement.classList.remove('active');
                    this.lightbox.classList.remove('active');
                    this.bodyElement.classList.remove('noscroll')
                });
            }

            if (this.lightbox) {
                this.lightbox.addEventListener('click', (event) => {
                    if (event.target === this.lightbox) {
                        this.galleryElement.classList.remove('active');
                        this.lightbox.classList.remove('active');
                        this.bodyElement.classList.remove('noscroll');
                    }
                });
            }

            const prevBtnFs = this.lightbox.querySelector('.prev-btn-fs');
            if (prevBtnFs) {
                prevBtnFs.addEventListener('click', () => {
                    this.navigateLightbox(-1);
                });
            }

            const nextBtnFs = this.lightbox.querySelector('.next-btn-fs');
            if (nextBtnFs) {
                nextBtnFs.addEventListener('click', () => {
                    this.navigateLightbox(1);
                });
            }
        }
    }

    private openLightbox(index: number): void {
        if (!this.lightbox || !this.lightboxImg) return;
        this.currentIndex = index;
        const img = this.items[index].querySelector('img');
        if (img) {
            this.lightboxImg.src = img.getAttribute('data-full-img') || img.src;
            this.galleryElement.classList.add('active');
            this.lightbox.classList.add('active');
            this.bodyElement.classList.add('noscroll')
        }
    }

    private navigateLightbox(direction: number): void {
        if (!this.lightbox || !this.lightboxImg) return;
        this.currentIndex = (this.currentIndex + direction + this.items.length) % this.items.length;
        const img = this.items[this.currentIndex].querySelector('img');
        if (img) {
            this.lightboxImg.src = img.getAttribute('data-full-img') || img.src;
        }
    }

    private scrollByDirection(direction: number): void {
        if (!this.slider || this.items.length === 0) return;
        const slideWidth = this.items[0].getBoundingClientRect().width + 28;
        this.slider.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
    }
}

export default OiImageGallery;